// Copyright (c) Docugami, Inc. All rights reserved.

import { StorageAccessor, StorageKey } from 'utils/StorageAccessor';
import { v4 as uuidv4 } from 'uuid';

/**
 * Manages the different correlation IDs used on the client
 */
export class ClientCorrelationIds {
    private _instanceId: string = '';
    private _localSessionId: string = '';
    private _globalSessionId: string = '';

    get instanceId(): string {
        if (!this._instanceId) {
            this._instanceId = uuidv4();
        }

        return this._instanceId;
    }

    get localSessionId(): string {
        if (!this._localSessionId) {
            this._localSessionId = this.getId(StorageKey.TelemetryClientLocalSessionId, new StorageAccessor(window.sessionStorage));
        }

        return this._localSessionId;
    }

    get globalSessionId(): string {
        if (!this._globalSessionId) {
            this._globalSessionId = this.getId(StorageKey.TelemetryClientGlobalSessionId, new StorageAccessor(window.localStorage));
        }

        return this._globalSessionId;
    }

    private getId(key: StorageKey, storage: StorageAccessor): string {
        let id = storage.getString(key);
        if (!id) {
            id = uuidv4();
            storage.setString(key, id);
        }

        return id;
    }
}
